import dayjs from 'dayjs';

export const isChangeoverDay = (segments) => {
  const formattedDates = segments.map((segment) => ({
    startDay: dayjs(segment.startDate).format('YYYY-MM-DD'),
    endDay: dayjs(segment.endDate).format('YYYY-MM-DD'),
  }));

  const datesSet = new Set();

  for (const { startDay, endDay } of formattedDates) {
    if (datesSet.has(startDay)) {
      return true;
    }
    datesSet.add(endDay);
  }

  return false;
};

export const isDateInPast = (currentDate) => {
  return currentDate.isBefore(dayjs(), 'day');
};

export const isDateWithinUnavailableRanges = (
  currentDate,
  unavailableDates
) => {
  if (unavailableDates?.length > 0) {
    return !!unavailableDates.find(({ startDateIso, endDateIso }) => {
      const start = dayjs(startDateIso).startOf('day');
      const end = dayjs(endDateIso).startOf('day');
      const date = dayjs(currentDate).startOf('day');

      return date.isBetween(start, end, 'day', '[]'); 
    });
  }
  return false;
};

export function isDateAvailable(state, date) {
  if (state === undefined) {
    return false;
  }

  if (state.bookabilityState === 'allDatesBookable') {
    return true;
  }

  if (state.bookabilityState === 'noDatesBookable') {
    return false;
  }

  if (state.bookabilityState === 'onlyReturnedDatesBookable') {
    return state.bookableDates.includes(date);
  }

  throw new Error('Invalid bookability state');
}
